export const LOGIN = (context, callback) => {
  context.commit('LOGIN')
}

export const LOGOUT = (context, callback) => {
  context.commit('LOGOUT')
}



// WEBPACK FOOTER //
// ./src/store/actions.js